import React from 'react';
import { Props } from '../MonoView';
import { useEditorContainerSize } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import cn from 'classnames';
import { useFreeformSquareSizing } from '../helpers';
import EditorDeviationLink from '../_partials/DeviationLink';
import DumbView from '../../../DeviationViews/Dumbo/EditorDumbo';
import PriceWithPoints from '../../../ShopCard/_partials/PriceWithPoints';
import { getDeviationPrice } from '../../../utils/deviations';
import { formatDollars } from '../../../utils/formatting';
import Flex from '@wix/da-ds/pkg/Flex';
import UserAvatar from '../../../User/Avatar/UserAvatar';
import UserLink from '../../../User/Link/UserLink';

import s from './Commission.scss';

const CommissionMonoView: React.FC<Props> = props => {
  const containerSize = useEditorContainerSize();
  const { deviation, extOptions, width: propsWidth, link } = props;
  const size = useFreeformSquareSizing(propsWidth, extOptions, containerSize);
  const { dollarsPrice, pointsPrice } = getDeviationPrice(deviation);
  const { title, author } = deviation;

  return (
    <div className={cn(s['root'])} style={{ width: size.width }}>
      <EditorDeviationLink link={link} deviation={deviation}>
        <DumbView
          className={s['thumb']}
          width={size.width - 2}
          height={size.height}
          deviation={deviation}
        />
        <div>
          <Flex direction="column" className={s['details']}>
            <Flex direction="row" alignItems="stretch">
              <div className={s['left-cell']}>
                <div className={s['avatar']}>
                  <UserAvatar user={author} size={28} />
                </div>
              </div>
              <div className={cn(s['two-center-cells'])}>
                <div className={s['title']}>{title}</div>
                {author && <div className={s['username']}>{<UserLink user={author} />}</div>}
              </div>
              <div className={s['right-cell']}>
                <PriceWithPoints
                  formattedDollarsPrice={formatDollars(dollarsPrice)}
                  pointsPrice={pointsPrice}
                />
              </div>
            </Flex>
          </Flex>
        </div>
      </EditorDeviationLink>
    </div>
  );
};
CommissionMonoView.displayName = 'CommissionMonoView';

export default CommissionMonoView;
